import { render, staticRenderFns } from "./addEmbedded.vue?vue&type=template&id=08bdcb22"
import script from "./addEmbedded.vue?vue&type=script&lang=js"
export * from "./addEmbedded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports